import { Input } from 'components/atoms';
import { IInputTextEditorProps } from 'components/atoms/inputs/text-editor/InputTextEditor';
import { useFormikField } from 'hooks/useFormikField';

const FormInputTextEditor = ({
  name = '',
  ...props
}: IInputTextEditorProps) => {
  const [_, { error, value, status }, { setValue }] =
    useFormikField<string>(name);

  return (
    <Input.Editor
      {...props}
      //   loading={status?.isLoading}
      name={name}
      disabled={props.disabled ?? status?.isLoading}
      value={value}
      editorOptions={{
        ...props.editorOptions,
        content: '',
        onUpdate: update => {
          props.editorOptions?.onUpdate &&
            props.editorOptions?.onUpdate(update);

          setValue(update.editor.getHTML());
        },
      }}
      error={error}
    />
  );
};
export default FormInputTextEditor;
